import { Box, Typography } from "@bca/ui-library";

import { Vehicle } from "../Interfaces/vehicle.type";
import { formatCollectionDate } from "../formatCollectionDate";
import TruckSvg from "../Icons/TruckSvg";
import LocationPinSVG from "../Icons/LocationPinSVG";

interface DeliveryProps {
  vehicle: Vehicle;
  degradedServices: string[];
}

const Delivery: React.FunctionComponent<DeliveryProps> = ({ vehicle }) => {
  let iconColor = "primary-navy-blue";
  let statusColor = "footer-blue";
  if (vehicle.orderState.status === "Cancelled") {
    iconColor = "primary-red";
    statusColor = "primary-red";
  }
  if (vehicle.orderState.status === "Delivered") {
    iconColor = "secondary-green";
    statusColor = "secondary-green";
  }

  const deliveryStatusIcon =
    vehicle.orderState.status === "Export" ||
    vehicle.orderState.status === "Exported" ? (
      <LocationPinSVG />
    ) : (
      <TruckSvg fill={iconColor} />
    );

  return (
    <Box display="flex" flexDirection="row" alignItems="flex-start" width="50%">
      {deliveryStatusIcon}
      <Box display="flex" flexDirection="column" marginLeft={2}>
        <Typography
          variant="h6"
          color={statusColor}
          fontWeight="medium"
          marginTop={0}
          marginBottom={1}
        >
          {vehicle.orderState.status}
        </Typography>
        <Typography
          variant="label"
          color="footer-blue"
          htmlTag="p"
          margin={0}
          marginRight={1}
          fontWeight="normal"
        >
          {formatCollectionDate(vehicle.orderState.date)}
        </Typography>
      </Box>
    </Box>
  );
};

export default Delivery;
